export default __webpack_public_path__ + "static/media/Padron_MagnumClosed.34d7c1a7.jpg";